// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"318":"33c4e430","581":"9be8ed1b","943":"a7aa0490"}[chunkId] + ".css";
};